module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0091.jpg?v=5a97175b";